import { render, staticRenderFns } from "./SalesTargets.vue?vue&type=template&id=8ad0e2d2&"
import script from "./SalesTargets.vue?vue&type=script&lang=js&"
export * from "./SalesTargets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports